import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClubLandingPageComponent } from '../../landing-pages/club/landing-page.component';
import { KingClubAssets } from '../../shared/enum/icons';
import { PanelService } from '../../shared/services/api/panel.service';
import { StateService } from '../../shared/services/storage/state.service';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ProfileResolverService } from '../../shared/services/resolver/profile-resolver.service';
import { ToastService } from '../../shared/services/toast.service';

@Component({
    selector: 'app-account-switch-dialog',
    templateUrl: './account-switch-dialog.component.html',
    styleUrls: ['./account-switch-dialog.component.scss'],
    standalone: true,
    imports: [AsyncPipe, MatButtonModule, MatDialogModule]
})
export class AccountSwitchDialogComponent implements OnInit {
  private profileResolver = inject(ProfileResolverService);
  dialogRef = inject<MatDialogRef<ClubLandingPageComponent>>(MatDialogRef);
  private router = inject(Router);
  private panelService = inject(PanelService);
  private toastService = inject(ToastService);
  private stateService = inject(StateService);
  data = inject(MAT_DIALOG_DATA);

  icons = KingClubAssets;
  isLoggedIn: Observable<boolean>;

  ngOnInit(): void {
    this.isLoggedIn = this.stateService.getLoginStatus();
    if (this.data.joinAfterLogin) {
      this.switchAccount();
    }
  }

  switchAccount() {
    this.panelService.joinKingClub().subscribe(
      {
        next: () => {
          this.profileResolver.updateInfo().subscribe();
          this.toastService.show({
            message: 'Congrats! You Are a Member of KingClub!',
            type: 'success',
            duration: 2000
          });
          this.stateService.setClubMembershipState(true);
          this.router.navigate(['/kingclub/club-levels']);
        },
        error: (error) => {
          this.toastService.show({
            message: error?.error?.message ?? 'Joining KingClub Failed!',
            type: 'error',
            duration: 2000
          });
        }
      }
    );
  }

  cancel() {
    this.dialogRef.close();
  }

  loginToJoin() {
    this.router.navigate(['/authenticate/login']);
  }
}
